<template>
  <div class="sectionOuterBox bgBlue">
    <div class="sectionInnerBox">
      <v-container class="container sectionContainer headlineSectionContainer">
        <v-row>
          <v-col cols="12" md="5">
            <div class="sectionHeader headlineSectionHeader">
              <h1 class="headLineText">{{ $t('teachers.headline.title') }}</h1>
              <h2 class="subText font-weight-thin">
                {{ $t('teachers.headline.subtitle') }}
              </h2>
              <div>
                <button
                  class="signup doSignup"
                  @click="signUp"
                  @keydown.enter="signUp"
                  :title="$t('common.trial.title')"
                  :aria-label="$t('common.trial.ariaLabel')"
                  type="button"
                >
                  {{ $t('common.trial.text') }}
                </button>
              </div>
            </div>
          </v-col>
          <v-col class="headlineImageContainer" cols="12" md="7">
            <img class="headlineImage" src="https://cdn.planbook.com/images/welcome-teachers-c.png" alt="">
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import CommonUtils from '@/utils/common-utils';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Headline extends Vue {
  signUp() {
    CommonUtils.doSignUp();
  }
}
</script>

<style lang="scss" scoped>
.sectionInnerBox {
  padding: 0;
}

.headlineSectionContainer {
  background-image: url('https://cdn.planbook.com/images/welcome-teacher-bg.jpg');
  background-size: cover;
  background-position: center;
  padding: 33px 30px;
}

.headlineImageContainer {
  position: relative;
  height: 342px;
}

@media screen and (max-width: 960px) {
  .headlineImageContainer {
    height: 255px;
  }
}

@media screen and (max-width: 600px) {
  .headlineImageContainer {
    height: 140px;
  }
}

@media screen and (max-width: 1199px) and (min-width: 992px) {
  .headlineImageContainer {
    top: 40px;
  }
}

@media screen and (max-width: 991px) and (min-width: 960px) {
  .headlineImageContainer {
    top: 78px;
  }
}

.signup {
  font-family: Raleway, Arial, Helvetica, sans-serif;
  border: 4px solid #FFFFFF;
  color: white;
  background-color: #d81632;
  padding: 14px 20px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 20px;
  box-shadow: 0 0 15px #2b2b2b;
  display: inline-block;
  -moz-box-shadow: 0 0 15px #2b2b2b;
  -webkit-box-shadow: 0 0 15px #2b2b2b;
  cursor: pointer;
}
</style>
